// @flow
import { getBgColorKey, saveStates } from '~/core/constants/components/widgets/buttons/async';

import styled from 'styled-components';

export const AsyncBtn = styled.button`
    background-color: ${({ theme: { primaryBtnColors }, saveState, disabled }) =>
        disabled && saveState === saveStates.DEFAULT
            ? primaryBtnColors.disabled
            : primaryBtnColors[getBgColorKey(saveState)]};
    border: ${({ theme: { primaryBtnColors }, disabled }) =>
        disabled ? `1px solid ${primaryBtnColors.disabled}` : `1px solid ${primaryBtnColors.default}`};
    border-radius: 1.5em;
    color: ${({ theme }) => theme.white};
    cursor: ${({ disabled, saveState }) => (!disabled && saveState === saveStates.DEFAULT ? 'pointer' : 'default')};
    font-size: 1em;
    height: 2.65em;
    outline: none;
    width: 8em;

    ${({ disabled, saveState, theme: { primaryBtnColors } }) => {
        if (!disabled && saveState === saveStates.DEFAULT) {
            return `
				&:hover {
					background-color: ${primaryBtnColors.hover};
					transition: background-color 0.5s ease-in-out;
				}
			`;
        } else {
            return '';
        }
    }};

    &:focus {
        box-shadow: 0 0 10px 0 rgba(255, 122, 0, 0.5);
    }
`;

export const ContentContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-start;
`;

export const SaveTextWrapper = styled.div`
    position: relative;
    flex-grow: 2;
    height: 1em;
`;

export const SaveText = styled.div`
    text-align: center;
    display: block;
    position: absolute;
    width: 100%;
    transition: opacity 0.5s ease-in-out;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: ${({ saveState, thisState }) => (saveState === thisState ? 1 : 0)};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/async/styles.js